import type { HomepageGoal, HomepageStage } from "./homepage.types";

/**
 * Donor-specific lifecycle stages belong to the donor journey. A corrected
 * goal may intentionally retain the old fertility-intent stage, so project
 * those stages back to the generic journey without rewriting the record.
 */
export function normalizeHomepageStageForGoal(
  goal: HomepageGoal,
  stage: HomepageStage,
): HomepageStage {
  const isHelperGoal =
    goal === "egg-donation" ||
    goal === "sperm-donation" ||
    goal === "surrogacy";
  const isHelperStage =
    stage === "screening" ||
    stage === "matched" ||
    stage === "approved" ||
    stage === "donating";

  return !isHelperGoal && isHelperStage ? "before-treatment" : stage;
}
